import React from 'react';
import { titleize } from 'underscore.string';
import { t } from 'i18next';
import formatMoney from 'utils/formatters/Money';
import CargomaticLabel from 'components/v2/forms/Label';
export const helptext = {
    PROCESSED: 'ACCESSORIALS_TOOLTIP_PROCESSED',
    UNITS: 'ACCESSORIALS_TOOLTIP_UNITS',
    RATE: 'ACCESSORIALS_TOOLTIP_RATE',
    SHIPPER_NOTES: 'ACCESSORIALS_TOOLTIP_SHIPPER_NOTES',
    CARRIER_NOTES: 'ACCESSORIALS_TOOLTIP_CARRIER_NOTES',
};
export function getUnitLabel(units, unitName) {
    if (unitName === 'hourly') {
        return t('COUNT_HOUR', { count: units, hourCount: units });
    }
    if (unitName === 'daily') {
        return t('COUNT_DAY', { count: units, dayCount: units });
    }
    return units;
}
export function renderUnits(t, qty, referenceAccessorial) {
    if (!referenceAccessorial) {
        return '-';
    }
    return (React.createElement("div", { "data-testid": "div-e3a16c24", className: "" },
        React.createElement(CargomaticLabel, { dataTestId: "CargomaticLabel-ceb70659", helptext: t(helptext.UNITS), className: "mb-1" }, t('UNIT', { count: 3 })),
        React.createElement("div", { "data-testid": "div-617cf8ee" }, getUnitLabel(qty, referenceAccessorial.rate_type))));
}
export function renderRate(t, rate, currency) {
    const rateDisplay = rate ? formatMoney(parseFloat(rate), currency) : '-';
    return (React.createElement("div", { "data-testid": "div-24578187", className: "" },
        React.createElement(CargomaticLabel, { dataTestId: "CargomaticLabel-3cbf7166", helptext: t(helptext.RATE), className: "mb-1" }, t('RATE_PER_UNIT')),
        React.createElement("div", { "data-testid": "div-b58d68e4" }, rateDisplay)));
}
export function renderDeclineCode(t, declineReasonCode) {
    return (React.createElement("div", { "data-testid": "div-c26d72bd", className: "" },
        React.createElement(CargomaticLabel, { dataTestId: "CargomaticLabel-248103db", className: "mb-1" },
            titleize(t('REASON_CODE')),
            ":"),
        React.createElement("div", { "data-testid": "div-350702a5", className: "truncate" }, declineReasonCode)));
}
export function renderNotes(t, note, isCarrier = false) {
    const notesHelptext = isCarrier
        ? helptext.CARRIER_NOTES
        : helptext.SHIPPER_NOTES;
    return (React.createElement("div", { "data-testid": "div-b1d131b8", className: "" },
        React.createElement(CargomaticLabel, { dataTestId: "CargomaticLabel-8e212bbf", helptext: t(notesHelptext), className: "mb-1" }, titleize(t('NOTE', { count: 3 }))),
        React.createElement("div", { "data-testid": "div-a606fe19", className: "truncate" }, note || '-')));
}
